<template>
  <div v-if="visual" :class="rootClass">
    <h2 v-if="mode === 'demo' && showTitle" class="doc-format-demo-title">{{ demoTitle }}</h2>
    <div :class="flowClass">
      <div class="doc-format-side doc-format-side--source" :style="sourceSideStyle">
        <span v-if="mode === 'demo'" class="doc-format-side-label">{{ sourceLabel }}</span>
        <div class="doc-format-card" :style="cardStyle(visual.source)">
          <div class="doc-format-badge" :style="{ color: visual.source.color }">
            <span class="doc-format-badge-text">{{ visual.source.label }}</span>
          </div>
          <div v-if="visual.source.multi" class="doc-format-multi">
            <div class="doc-format-thumb" v-for="n in 3" :key="'s' + n" :style="{ '--i': n }">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="9" cy="11" r="2"/><path d="M21 16l-5-5-3 3-2-2-4 4"/></svg>
            </div>
          </div>
          <div v-else-if="visual.source.image" class="doc-format-image-mock">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="9" cy="11" r="2"/><path d="M21 16l-5-5-3 3-2-2-4 4"/></svg>
          </div>
          <div v-else-if="visual.source.grid" class="doc-format-grid">
            <span v-for="n in 9" :key="'g' + n"></span>
          </div>
          <div v-else class="doc-format-lines">
            <span
              v-for="n in (visual.source.lines || 4)"
              :key="'l' + n"
              :style="{ width: lineWidth(n, visual.source.lines || 4) }"
            ></span>
          </div>
        </div>
      </div>

      <div class="doc-format-arrow" aria-hidden="true">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M5 12h14M12 5l7 7-7 7"/>
        </svg>
      </div>

      <div class="doc-format-side doc-format-side--target" :style="targetSideStyle">
        <span v-if="mode === 'demo'" class="doc-format-side-label">{{ targetLabel }}</span>
        <div class="doc-format-card" :style="cardStyle(visual.target)">
          <div class="doc-format-badge" :style="{ color: visual.target.color }">
            <span class="doc-format-badge-text">{{ visual.target.label }}</span>
          </div>
          <div v-if="visual.target.stack" class="doc-format-stack">
            <div class="doc-format-stack-page" v-for="n in 3" :key="'p' + n" :style="{ '--i': n }">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="9" cy="11" r="2"/><path d="M21 16l-5-5-3 3-2-2-4 4"/></svg>
            </div>
          </div>
          <div v-else-if="visual.target.image" class="doc-format-image-mock">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="9" cy="11" r="2"/><path d="M21 16l-5-5-3 3-2-2-4 4"/></svg>
          </div>
          <div v-else-if="visual.target.grid" class="doc-format-grid">
            <span v-for="n in 9" :key="'tg' + n"></span>
          </div>
          <div v-else class="doc-format-lines">
            <span
              v-for="n in (visual.target.lines || 4)"
              :key="'tl' + n"
              :style="{ width: lineWidth(n, visual.target.lines || 4) }"
            ></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var getDocConvertVisual = require('@/config/docConvertVisuals').getDocConvertVisual

export default {
  name: 'DocFormatCover',
  props: {
    toolId: { type: String, required: true },
    mode: {
      type: String,
      default: 'cover'
    },
    showTitle: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    visual: function () {
      return getDocConvertVisual(this.toolId)
    },
    rootClass: function () {
      return ['doc-format-cover', 'doc-format-cover--' + this.mode]
    },
    flowClass: function () {
      return this.mode === 'demo' ? 'doc-format-demo-flow' : 'doc-format-cover-flow'
    },
    demoTitle: function () {
      return this.$t('tools.convert.demoTitle')
    },
    sourceLabel: function () {
      return this.$t('tools.convert.sourceLabel')
    },
    targetLabel: function () {
      return this.$t('tools.convert.targetLabel')
    },
    sourceSideStyle: function () {
      if (this.mode !== 'cover' || !this.visual) return {}
      return { background: this.visual.source.bg }
    },
    targetSideStyle: function () {
      if (this.mode !== 'cover' || !this.visual) return {}
      return { background: this.visual.target.bg }
    }
  },
  methods: {
    cardStyle: function (format) {
      if (this.mode === 'cover') {
        return { background: '#fff', color: format.color }
      }
      return { background: format.bg, color: format.color }
    },
    lineWidth: function (index, total) {
      if (index === total) return '55%'
      if (index === 1) return '88%'
      return '72%'
    }
  }
}
</script>

<style scoped>
.doc-format-cover {
  width: 100%;
  height: 100%;
}

.doc-format-cover-flow {
  position: relative;
  display: flex;
  align-items: stretch;
  width: 100%;
  height: 100%;
}

.doc-format-cover--cover .doc-format-side--source {
  border-right: 1px solid rgba(255, 255, 255, 0.65);
}

.doc-format-cover--cover .doc-format-arrow {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.12);
}

.doc-format-side {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px 8px;
}

.doc-format-cover--cover .doc-format-side {
  padding: 8px 6px;
}

.doc-format-cover--cover .doc-format-card {
  width: 58%;
  max-width: 80px;
  padding: 6px;
  gap: 4px;
  border-radius: 6px;
  box-shadow: 0 1px 6px rgba(15, 23, 42, 0.1);
}

.doc-format-cover--cover .doc-format-badge-text {
  font-size: 10px;
}

.doc-format-badge-text {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.02em;
}

.doc-format-cover--cover .doc-format-lines {
  gap: 3px;
}

.doc-format-cover--cover .doc-format-lines span {
  height: 2px;
}

.doc-format-cover--cover .doc-format-image-mock svg,
.doc-format-cover--cover .doc-format-thumb svg,
.doc-format-cover--cover .doc-format-stack-page svg {
  max-width: 28px;
}

.doc-format-cover--cover .doc-format-multi,
.doc-format-cover--cover .doc-format-stack {
  min-height: 24px;
}

.doc-format-cover--cover .doc-format-arrow {
  width: 20px;
  height: 20px;
}

.doc-format-cover--cover .doc-format-arrow svg {
  width: 14px;
  height: 14px;
}

.doc-format-card {
  width: 100%;
  max-width: 120px;
  aspect-ratio: 3 / 4;
  border-radius: 8px;
  padding: 8px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 6px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.8);
}

.doc-format-badge {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1px;
  line-height: 1.1;
}

.doc-format-lines {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
}

.doc-format-lines span {
  display: block;
  height: 3px;
  border-radius: 2px;
  background: currentColor;
  opacity: 0.18;
}

.doc-format-grid {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 3px;
  align-content: center;
}

.doc-format-grid span {
  aspect-ratio: 1;
  border-radius: 2px;
  background: currentColor;
  opacity: 0.14;
}

.doc-format-image-mock,
.doc-format-thumb,
.doc-format-stack-page {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: inherit;
  opacity: 0.35;
}

.doc-format-image-mock svg,
.doc-format-thumb svg,
.doc-format-stack-page svg {
  width: 100%;
  max-width: 42px;
  height: auto;
}

.doc-format-multi {
  flex: 1;
  position: relative;
  min-height: 36px;
}

.doc-format-thumb {
  position: absolute;
  width: 52%;
  aspect-ratio: 1;
  background: rgba(255, 255, 255, 0.55);
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  padding: 4px;
  box-sizing: border-box;
}

.doc-format-thumb:nth-child(1) { left: 4%; top: 8%; transform: rotate(-8deg); z-index: 1; }
.doc-format-thumb:nth-child(2) { left: 24%; top: 18%; transform: rotate(4deg); z-index: 2; }
.doc-format-thumb:nth-child(3) { left: 44%; top: 4%; transform: rotate(-3deg); z-index: 3; }

.doc-format-stack {
  flex: 1;
  position: relative;
  min-height: 36px;
}

.doc-format-stack-page {
  position: absolute;
  width: 58%;
  aspect-ratio: 3 / 4;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  padding: 4px;
  box-sizing: border-box;
}

.doc-format-stack-page:nth-child(1) { left: 8%; top: 12%; transform: rotate(-6deg); z-index: 1; }
.doc-format-stack-page:nth-child(2) { left: 22%; top: 6%; transform: rotate(2deg); z-index: 2; }
.doc-format-stack-page:nth-child(3) { left: 36%; top: 0; transform: rotate(8deg); z-index: 3; }

.doc-format-arrow {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  color: var(--text-muted, #94a3b8);
}

.doc-format-arrow svg {
  width: 18px;
  height: 18px;
}

/* demo mode */
.doc-format-cover--demo {
  margin: 32px auto 0;
  padding: 24px;
  background: var(--bg-primary);
  border-radius: var(--radius-lg);
  max-width: 760px;
}

.doc-format-demo-title {
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  margin: 0 0 20px;
}

.doc-format-demo-flow {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.doc-format-cover--demo .doc-format-side {
  flex: 0 1 200px;
  padding: 0;
}

.doc-format-cover--demo .doc-format-card {
  max-width: none;
  width: 100%;
  padding: 14px;
}

.doc-format-cover--demo .doc-format-badge-text {
  font-size: 15px;
}

.doc-format-side-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-muted);
  margin-bottom: 8px;
  text-align: center;
}

.doc-format-cover--demo .doc-format-arrow svg {
  width: 32px;
  height: 32px;
}

@media (max-width: 640px) {
  .doc-format-demo-flow {
    flex-direction: column;
    gap: 12px;
  }

  .doc-format-cover--demo .doc-format-side {
    width: 100%;
    max-width: 220px;
  }

  .doc-format-cover--demo .doc-format-arrow {
    transform: rotate(90deg);
  }
}
</style>
